module.exports = __webpack_public_path__ + "img/create.7a97a595.png";